import React from 'react'

const Ubicacion = ({english}) => {
    return (
        <div id="ubicacion" >
            <h2 className="titulo">{english ? 'LOCATION' : 'Ubicación'}</h2>
            <div >
              <iframe 
                title={`Inline Frame Ubicacion`}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7947.618581360652!2d-99.85418545542841!3d16.795001544399426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ca591f1ac0b787%3A0x2cf57fda59587ad!2sCabo%20Marqu%C3%A9s%2C%20Punta%20Diamante%2C%20Acapulco%20de%20Ju%C3%A1rez%2C%20Gro.!5e1!3m2!1ses!2smx!4v1618983715523!5m2!1ses!2smx" 
                width="100%" height="600" 
                style={{marginTop: 20}}
                frameBorder="0" 
                scrolling="no" 
                marginHeight="0" 
                marginWidth="0"
                loading="lazy"></iframe>
            </div>
        </div>
    )
}

export default Ubicacion